var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBdaiatMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.764 0.936H10.437C11.462 0.936 12.276 1.782 12.276 2.813V11.591C12.276 12.331 11.856 12.966 11.225 13.283C10.831 13.468 10.332 13.362 10.016 13.045L0.345 3.236C0.003 2.892 -0.102 2.416 0.108 1.993C0.397 1.385 1.028 0.936 1.764 0.936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdaiatMark);
export default __webpack_public_path__ + "static/media/bdaiatMark.c7c602e7a1ebf0b73f6ede5de11efaec.svg";
export { ForwardRef as ReactComponent };